import { createApplicationState } from '../applicationState';
import { renderApplication } from '../renderApplication';
import { createContext } from './createContext';
import { loadCareerPage } from 'career-entry';
import { EPageType } from '../../../shared/types/page';

export function runApp() {
  const context = createContext();

  const store = createApplicationState(context);

  if ([EPageType.Career, EPageType.CareerVacancies, EPageType.CareerVacancy].includes(store.getState?.()?.page?.type)) {
    void loadCareerPage().then(() => renderApplication({ context, store }));

    return;
  }

  renderApplication({ context, store });
}
